import { SymbolDisplay, SymbolDisplaySize, Text } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';
import type { PriceGridEntity } from '../PriceGridEntity';

export type PriceGridSymbolCellRendererProps = Pick<
  ICellRendererParams<PriceGridEntity, string>,
  'data' | 'value' | 'valueFormatted'
>;

export function PriceGridSymbolCellRenderer({ data, valueFormatted, value }: PriceGridSymbolCellRendererProps) {
  const symbol = data?.security.Symbol;
  const label = valueFormatted ?? value ?? '';

  if (!symbol) {
    return <Text>{label}</Text>;
  }

  return <SymbolDisplay symbol={symbol} showDescription={false} size={SymbolDisplaySize.Small} />;
}
